<template>
  <li class="my-2">
    <font-awesome-icon
      icon="dot-circle"
      :class="'state-'+sensor.state"
      style="transform: scale(2.2)"
    />
    <span
      :class="getBadge(sensor.state)+' clickable'"
      @click="showPopper($event,sensor)"
    >{{sensor.id}} - {{$t('state.msgs.'+sensor.state)}}</span>
  </li>
</template>

<script>
import { getBadge } from "../../sheriffUtils.js";
export default {
  name: "ObstructionSensorView",
  props: {
    sensor: {
      required: true,
      type: Object
    }
  },
  methods: {
    showPopper(event) {
      this.$root.$emit("show-popper", event, this.sensor);
    },
    getBadge
  }
};
</script>

<style>
</style>
